import { FC } from "react";
import { Button, Card, Space } from "antd";

const expenses = [
  { name: "Fuel", amount: 875.5, change: "12% vs. last month" },
  { name: "Maintenance", amount: 1245.0, change: "25% vs. last month" },
  { name: "Insurance", amount: 650.0, change: "No change" },
  { name: "Other", amount: 125.75, change: "3% vs. last month" },
];

export const ExpenseTracking: FC = () => {
  return (
    <Card
      title="Expense Tracking"
      className="rounded-lg border border-gray-200"
      headStyle={{ fontWeight: 500 }}
    >
      <div className="flex justify-between items-center mb-4">
        <h3 className="font-medium text-base">Expense Tracking</h3>
        <Space size="small">
          <Button className="border-gray-300 hover:bg-gray-50">
            This Month
          </Button>
          <Button className="border-gray-300 hover:bg-gray-50">
            Last Month
          </Button>
          <Button className="border-gray-300 hover:bg-gray-50">Custom</Button>
        </Space>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {expenses.map((expense, idx) => (
          <Card key={idx} className="rounded-lg border border-gray-200 p-4">
            <div className="text-sm text-gray-500">{expense.name}</div>
            <div className="text-xl font-medium mt-1">
              ${expense.amount.toFixed(2)}
            </div>
            <div className="text-xs text-gray-500 mt-1">{expense.change}</div>
          </Card>
        ))}
      </div>
      <div className="flex justify-end mt-4">
        <Button className="border-gray-300 hover:bg-gray-50">
          View Detailed Report
        </Button>
      </div>
    </Card>
  );
};
